

$("#profile_language_selector").on('change',function(){
		updateUserLanguage($(this).val());
});


const languagesName = new Intl.DisplayNames(['en'], { type: 'language' });

function createModalBoxLanguages(){

    addPageToState('modal-generic');

    var html='';
    if (companyLanguages.length > 1) {
        companyLanguages.forEach(key => {
            
            let selected = '';
            if(currentLang == key){
                selected = 'selected';
            }
            html += `<div class="mod-custom-option ${selected} white" onclick="updateUserLanguage('${key}')">${languagesName.of(key)}</div>`;
        });
    }
    
    $('#modal-body-generic').html(`
        ${html}
    `);

    BSLight.ModalShow('#modal-generic');
}

function createModalBoxStreamsAndDownloadQuality(videoIds=null){
    addPageToState('modal-generic-sub');

    var html='';
    if(videoIds){
        html += `<p class="mt-2 text-center white bold">${translate('DOWNLOAD_QUALITY')}</p>`;
    }

    var quality = [
        {
            key: "best",
            name: translate('BEST'),
            info: "1.82 GB/hr"
        },
        {
            key: "good",
            name: translate('GOOD'),
            info: "0.77 GB/hr"
        },
        {   
            key: "data_saver",
            name: translate('DATA_SAVER'),
            info: "0.27 GB/hr"
        },
        {   
            key: "ask",
            name: translate('ALWAYS_ASK'),
            info: ""
        }
    ];

    for (var i = 0; i < quality.length; i++) {
        let selected = '';
        if(userData.download_quality == quality[i].key){
            selected = 'selected';
        }

        if(videoIds && quality[i].key=='ask'){
            continue;
        }


       html += `
        <div class="mod-custom-option ${selected} white" onclick="updateDownloadQuality('${quality[i].key}', ${videoIds ? `'${videoIds.join(",")}'` : 'null'})"><b>${quality[i].name}</b><br><span style="color:gray; font-size:12px;">${quality[i].info}</span></div>
        `;
    }
   
    $('#modal-body-generic-sub').html(`
        ${html}
    `);

    BSLight.ModalShow('#modal-generic-sub');
}

function updateDownloadQuality(quality, videoIds){
    checkGeneralCurrentState();
    if(videoIds){
        // videoIds = videoIds.split(",");
        startDownloadContentBatch(videoIds, quality, false);
        return false;
    }
    updateUserParam('download_quality', quality);
}


function createModalBoxStreamsAndDownload(){

    addPageToState('modal-generic');

    var html='';
            
    html += `
    <div class="pa-2">
        <div class="container-box-flex mt-1">
            <label class="checkbox style-e">
                <input value="1" type="checkbox" onclick="updateUserParam('notify_download_without_wifi', this.checked);" ${userData.notify_download_without_wifi  == true ? "checked" : ""}>
                <div class="checkbox__body white">${translate('NOTIFY_DOWNLOADING_WITHOUT_WIFI')}</div>
                <div class="checkbox__checkmark"></div>
            </label>
        </div>

        <div class="container-box-flex mt-1" onclick="createModalBoxStreamsAndDownloadQuality();" >
            <div class="left-element white xbold">
               ${translate('DOWNLOAD_QUALITY')}
               
            </div>
            <div class="right-element">
                <i class="ri-arrow-right-s-line"></i>
            </div>
        </div>

        <div class="container-box-flex mt-1">
            <label class="checkbox style-e">
                <input value="1" type="checkbox"  onclick="updateUserParam('notify_watch_without_wifi', this.checked);" ${userData.notify_watch_without_wifi == true ? "checked" : ""}>
                <div class="checkbox__body white">${translate('NOTIFY_WATCHING_WITH_MOBILE_DATA')}</div>
                <div class="checkbox__checkmark"></div>
            </label>
        </div>

        <p class="white bold mt-3">${translate('SPACE_USED')}</p>
        <div class="chart-container">
            <div class="chart-chart">
                <div class="chart-bar">
                    <div class="chart-user-space"></div>
                    <div class="chart-app-space" style="background-color:${companyPrimaryColor} !important;"></div>
                    <div class="chart-free-space"></div>
                </div>
            </div>
            <div class="chart-labels">
                <div class="chart-label chart-label-user"><i style="color:grey !important;" class="ri-circle-fill"></i> <span class="white">${translate('USED')}</span></div>
                <div class="chart-label chart-label-app"><i style="color:${companyPrimaryColor} !important;" class="ri-circle-fill"></i> <span class="white">${companyName}</span></div>
                <div class="chart-label chart-label-free"><i style="color:lightgray !important;" class="ri-circle-fill"></i> <span class="white">${translate('FREE_2')}</span></div>
            </div>
        </div>
    </div>
    `;
   
    $('#modal-body-generic').html(`
        ${html}
    `);

    BSLight.ModalShow('#modal-generic');
    

    const freeSpace = document.querySelector('.chart-free-space');
    const appSpace = document.querySelector('.chart-app-space');
    const userSpace = document.querySelector('.chart-user-space');

    try{
        var options = {};
        DiskSpacePlugin.info(
            options,
            function(info) {
                GB_DEVICE_SPACE = (info.total / (1024 * 1024 * 1024)).toFixed(2);
                GB_APP_SPACE = (info.app / (1024 * 1024 * 1024)).toFixed(2);
                GB_FREE_SPACE = (info.free / (1024 * 1024 * 1024)).toFixed(2);

                freeSpace.style.width = `${(GB_FREE_SPACE / GB_DEVICE_SPACE) * 100}%`;
                appSpace.style.width = `${(GB_APP_SPACE / GB_DEVICE_SPACE) * 100}%`;
                userSpace.style.width = `${((GB_DEVICE_SPACE - GB_APP_SPACE) / GB_DEVICE_SPACE) * 100}%`;
            },
            function(error) {
                console.error("Errore durante il recupero delle informazioni sullo spazio disco:", error);
            }
        );
    }catch(e){}

}


function updateUserParam(param, value){
    // alert(value);
    $.ajax({
        type: 'POST',
        data: param+"=" + value,
        url: URL_API + '/user/?f=save_settings',
        success: function () {
            userData[param] = value
        }
    });	
}

function updateUserLanguage(lang){
    $.ajax({
        type: 'POST',
        data: "language=" + lang,
        url: URL_API + '/user/?f=update_user_language',
        success: function () {
            reloadAppNow();
        }
    });	
}


function generateProfileSection(data){
    var htmlData = generateUserSection(data);
    $('.pageUserProfile').html(htmlData);
}

function useOauthLoginInWebProfile() {
    if (!window.TY_WEB) {
        return false;
    }
    var clerkEnabled = (typeof tyWebClerkEnabled === 'function')
        ? tyWebClerkEnabled()
        : !!(companySettings && companySettings.clerk_enabled);
    return !!companyAuth0Enabled || clerkEnabled;
}



function generateHtmlLogin(){
    var html = `
    <div class="col-md-12 row mb-3 text-center">
        <p class="white bold">${translate('LOGIN')} ${translate('OR')} ${translate('JOIN_NOW')}</p>
        <button onclick="generateAndHandleNewToken('login');" class="button-primary">${translate('LOGIN')}</button>
        <p class="white mt-1">${translate('OR')}</p>
        <button onclick="generateAndHandleNewToken('register');" class="button-secondary">${translate('JOIN_NOW')}</button>
    </div>`;

    return html;
}

function openModalLogin(){

    if(currentPageState[currentPageState.length-1] == 'modal-generic'){
        return false;
    }

    var html = generateHtmlLogin();
    if(companyLoginSkippable){
        addPageToState('modal-generic'); //da mettere solo qui per permettere lo skip
        html += `<button onclick="checkGeneralCurrentState();" class="button-void mt-2 button-full">`+translate('SKIP')+`</button>
          <div class="mt-5 gray text-center" style="font-size:12px;">
          <span class="bold white" onclick="openLinkTos();">${translate('TERMS_AND_CONDITIONS')}</span> - <span class="bold white" onclick="openLinkPrivacy();">${translate('PRIVACY_POLICY')}</span>
          </div>
        `;
    }
    $('#modal-body-generic').html(`
        ${html}
    `);
    if(!companyLoginSkippable){
        $('#modal-generic .modal-header').remove();
    }
    BSLight.ModalShow('#modal-generic');

}

function handleImageProfileSelect() {
    var fileInput = $('#profile_image_input')[0];
    
    if (fileInput.files && fileInput.files[0]) {
        var reader = new FileReader();
        
        reader.onload = function(e) {
            // Aggiorna l'src dell'immagine del profilo con i dati dell'immagine caricata
            $('.image-profile-general').attr('src', e.target.result);
            
            // Procedi con il caricamento al server se necessario
            uploadImageProfile(fileInput.files[0]);
        };
        
        reader.readAsDataURL(fileInput.files[0]);
    } else {
        // console.log('Nessun file selezionato');
    }
}

function uploadImageProfile() {
    var fileInput = $('#profile_image_input')[0];
    
    if (fileInput.files && fileInput.files[0]) {
        
        var formData = new FormData();
        formData.append('profile_image', fileInput.files[0]);
        $.ajax({
            url: URL_API+'/user/?f=save_settings', 
            type: 'POST',
            data: formData,
            processData: false,
            contentType: false,
            success: function(response) {
                // console.log('Immagine caricata con successo sul server:', response);
            },
            error: function(xhr, status, error) {
                // console.error('Errore nel caricamento dell\'immagine sul server:', error);
            }
        });
    } else {
        console.log('Nessun file selezionato');
    }
}

function generateUserSection() {

    let html = "";
    var htmlLogin = generateHtmlLogin();
    html += `
            <div class="">
                ${(userData.status != 'success') ? `
                    ${htmlLogin}
                    ` : `
                    <div class="profile-user-card">
                        <input onchange="handleImageProfileSelect();" type="file" id="profile_image_input" style="display:none;" accept="image/*">
                        <div class="profile-avatar-wrap" onclick="$('#profile_image_input').trigger('click');">
                            <img class="avatar_bg img-round image-profile-general" id="profile_image" src="${userData.profile_image}">
                            <div class="profile-avatar-edit"><i class="ri-camera-line"></i></div>
                        </div>
                        <div class="profile-user-info">
                            <p class="profile-user-name white">${userData.display_name}</p>
                            <p class="profile-user-email">${userData.email}</p>
                        </div>
                    </div>
                `}

                <div class="col-md-12 padding-0 profile-settings">
                    <p class="gray mb-1"> ${translate('PREFERENCES')} </p>

                    <!-- ogni gruppo e' un contenitore: su web diventa UNA card con
                         divisori (come la pagina Subscription), anche se alcune
                         righe sono nascoste da web.css -->
                    <div class="profile-settings-group">
                    <div class="container-box-flex"
                    ${(userData.status != 'success') ? `onclick="generateAndHandleNewToken('login');"`:``} >
                        <label class="checkbox style-e">
                            <input value="1"  onclick="updateUserParam('autoplay', this.checked);" type="checkbox" ${userData.autoplay == true ? "checked" : ""}>
                            <i class="ri-arrow-go-forward-line settings-icon"></i>
                            <div class="checkbox__body white">${translate('AUTOMATIC_PLAYBACK')}</div>
                            <div class="checkbox__checkmark"></div>
                        </label>
                    </div>

                    <div class="container-box-flex settings-row-downloads"
                    ${(userData.status != 'success') ? `onclick="generateAndHandleNewToken('login');"`:`onclick="createModalBoxStreamsAndDownload();"`}
                    >
                        <div class="left-element white xbold">
                            <i class="ri-wifi-line settings-icon"></i>
                            ${translate('STREAMS_AND_DOWNLOADS')}
                        </div>
                        <div class="right-element">
                            <i class="ri-arrow-right-s-line"></i>
                        </div>
                    </div>

                    ${(typeof companyLanguages !== 'undefined' && companyLanguages && companyLanguages.length > 1) ? `
                    <div class="container-box-flex"
                    ${(userData.status != 'success') ? `onclick="generateAndHandleNewToken('login');"`:`onclick="createModalBoxLanguages();"`}
                    >
                        <div class="left-element white xbold">
                            <i class="ri-translate-2 settings-icon"></i>
                            <label>Language</label>
                        </div>
                        <div class="right-element">
                            <div><span>${languagesName.of(currentLang)}</span></div>
                        </div>
                    </div>
                    ` : ''}
                    </div>

                    <p class="gray mb-1 mt-2"> Account </p>

                    <div class="profile-settings-group">
                    <div class="container-box-flex"
                     ${(userData.status != 'success') ? `onclick="generateAndHandleNewToken('login');"`:`onclick="openIapSettings();"`}
                    >
                        <div class="left-element white xbold">
                            <i class="ri-wallet-line settings-icon"></i>
                            <label>${translate('PAYMENTS')}  ${userData.has_mobile_payments ? `<span style="margin-left:15px;" class="label label-green">${translate('ENABLED')}</span>` : ''} </label>
                        </div>
                        <div class="right-element">
                            <i class="ri-arrow-right-s-line"></i>
                        </div>
                    </div>

                    ${window.TY_WEB ? `
                    <div class="container-box-flex"
                     ${(userData.status != 'success') ? `onclick="generateAndHandleNewToken('login');"`:`onclick="openChangePasswordSettings();"`}
                    >
                        <div class="left-element white xbold">
                            <i class="ri-lock-password-line settings-icon"></i>
                            <label>${translate('CHANGE_PASSWORD')}</label>
                        </div>
                        <div class="right-element">
                            <i class="ri-arrow-right-s-line"></i>
                        </div>
                    </div>
                    ` : ''}

                    ${window.TY_WEB && !useOauthLoginInWebProfile() ? `
                    <div class="container-box-flex"
                     ${(userData.status != 'success') ? `onclick="generateAndHandleNewToken('login');"`:`onclick="open2FASettings();"`}
                    >
                        <div class="left-element white xbold">
                            <i class="ri-shield-keyhole-line settings-icon"></i>
                            <label>2FA ${userData.twofa_configured ? `<span style="margin-left:15px;" class="label label-green">${translate('ENABLED')}</span>` : ''}</label>
                        </div>
                        <div class="right-element">
                            <i class="ri-arrow-right-s-line"></i>
                        </div>
                    </div>
                    ` : ''}

                    ${companySupportEmail ? `
                    <div id="settingsCompanySupportEmail" class="container-box-flex" onclick="openSupportEmail();">
                        <div class="left-element  white xbold">
                            <i class="ri-mail-line settings-icon"></i>
                            <label> ${translate('CONTACT_SUPPORT')}</label>
                        </div>
                        <div class="right-element">
                            <i class="ri-arrow-right-s-line"></i>
                        </div>
                    </div>
                    ` : ''}

                    <div class="container-box-flex" onclick="openLinkPrivacy();">
                        <div class="left-element  white xbold">
                            <i class="ri-file-lock-line settings-icon"></i>
                            <label>${translate('PRIVACY_POLICY')}</label>
                        </div>
                        <div class="right-element">
                            <i class="ri-arrow-right-s-line"></i>
                        </div>
                    </div>

                    <div class="container-box-flex" onclick="openLinkTos();">
                        <div class="left-element  white xbold">
                            <i class="ri-file-check-line settings-icon"></i>
                            <label>${translate('TERMS_AND_CONDITIONS')}</label>
                        </div>
                        <div class="right-element">
                            <i class="ri-arrow-right-s-line"></i>
                        </div>
                    </div>

                    <div class="container-box-flex" onclick="rateTheApp();">
                        <div class="left-element  white xbold">
                            <i class="ri-star-line settings-icon"></i>
                            <label>${translate('RATE_THE_APP')}</label>
                        </div>
                        <div class="right-element">
                            <i class="ri-arrow-right-s-line"></i>
                        </div>
                    </div>

                    ${(userData.status != 'success') ? ``:`
                    <div class="container-box-flex" onclick="logoutFromAccount();">
                        <div class="left-element  white xbold">
                            <i class="ri-logout-box-line settings-icon"></i>
                            <label>${translate('LOGOUT')}</label>
                        </div>
                        <div class="right-element">
                            <i class="ri-arrow-right-s-line"></i>
                        </div>
                    </div>

                    <div class="container-box-flex profile-settings-danger" onclick="deactivateTheAccount();">
                        <div class="left-element  white xbold">
                            <i class="ri-user-unfollow-line settings-icon"></i>
                            <label>${translate('DEACTIVATE_ACCOUNT')}</label>
                        </div>
                        <div class="right-element">
                            <i class="ri-arrow-right-s-line"></i>
                        </div>
                    </div>
                    `}
                    </div>
                </div>



                <div class="settings-app-version fs-s text-center mt-3 mb-3 white" style="opacity:0.6;">v${APP_VERSION}</div>
                
            </div>
                
            `;

    return html;
}

function openChangePasswordSettings() {
    if (!window.TY_WEB) {
        return false;
    }

    addPageToState('modal-generic');

    var html = `
        <div class="text-center pa-2">
            <h3 class="mb-3">${translate('CHANGE_PASSWORD')}</h3>
            <form id="changePasswordProfileForm">
                <div class="form-group mt-3">
                    <input class="form-control" type="password" id="new_password" name="new_password" placeholder="${translate('NEW_PASSWORD')}" required>
                    <label class="form-label">${translate('NEW_PASSWORD')}</label>
                </div>

                <div class="form-group mt-3">
                    <input class="form-control" type="password" id="confirm_password" name="confirm_password" placeholder="${translate('CONFIRM_NEW_PASSWORD')}" required>
                    <label class="form-label">${translate('CONFIRM_NEW_PASSWORD')}</label>
                </div>

                <button id="changePasswordBtn" class="button-primary mt-4" type="submit">${translate('SAVE')}</button>
            </form>
        </div>
    `;

    $('#modal-body-generic').html(html);
    BSLight.ModalShow('#modal-generic');

    $('#changePasswordProfileForm').off('submit').on('submit', function(e){
        e.preventDefault();
        var newPassword = $('#new_password').val();
        var confirmPassword = $('#confirm_password').val();

        if(newPassword !== confirmPassword){
            open_notifications_toast(translate('CONFIRMATION_PASSWORD_WRONG'), 'rgba(192, 57, 43, 1)');
            return;
        }

        $('#changePasswordBtn').prop('disabled', true);

        $.ajax({
            type: 'POST',
            url: URL_API + '/user/?f=set_new_password',
            data: { new_password: newPassword },
            success: function(response){
                var objJson = JSON.parse(response);
                if (objJson.status === "success") {
                    BSLight.ModalHide('#modal-generic');
                    open_notifications_toast(translate('PASSWORD_CHANGED_SUCCESSFULLY'), 'rgb(46, 182, 13)');
                } else {
                    var errorMessage = translate('ERROR');
                    if (objJson.type === 'invalid_password') {
                        errorMessage = `${translate('PASSWORD_NOT_VALID')} (${translate('PASSWORD_REQUIREMENTS')})`;
                    }
                    open_notifications_toast(errorMessage, 'rgba(192, 57, 43, 1)');
                }
                $('#changePasswordBtn').prop('disabled', false);
            },
            error: function(){
                $('#changePasswordBtn').prop('disabled', false);
                open_notifications_toast(translate('ERROR'), 'rgba(192, 57, 43, 1)');
            }
        });
    });
}

function open2FASettings() {
    if (!window.TY_WEB) {
        return false;
    }

    if (useOauthLoginInWebProfile()) {
        return false;
    }

    addPageToState('modal-generic');

    var html = '';
    if (!userData.twofa_configured) {
        html = `
            <div class="text-center pa-2">
                <h3 class="mb-3">${translate('CONFIGURE')} 2FA</h3>
                <div id="preCheckBox2FA">
                    <h4 class="white mb-2">${translate('PUT_YOUR_PASSWORD')}</h4>
                    <div class="form-group mt-3">
                        <input type="password" id="twofa_user_password" name="password" placeholder="Password" class="form-control">
                        <label class="form-label">Password</label>
                    </div>
                    <button id="save2FAbtn" class="button-primary mt-4" onclick="event.preventDefault(); check2FA();">${translate('VERIFICATION')}</button>
                </div>
                <div id="2FAresult" class="mt-3"></div>
                <div id="saveBox2FA" style="display:none;">
                    <h4 class="white mb-2">1. ${translate('SCAN_QR_CODE_ON_YOUR_GOOGLE_AUTHENTICATOR_APP')}.</h4>
                    <h4 class="white mb-2">2. ${translate('ENTER_THE_GENERATED_CODE_HERE')}:</h4>
                    <div class="form-group mt-3">
                        <input class="form-control" type="text" id="twofa_code" placeholder="123456">
                        <label class="form-label">2FA Code</label>
                    </div>
                    <button id="save2FAbtn" class="button-primary mt-4" onclick="event.preventDefault(); save2FA();">${translate('CONFIGURE')} 2FA</button>
                </div>
            </div>
        `;
    } else {
        html = `
            <div class="text-center pa-2">
                <h3 class="mb-3">${translate('REMOVE')} 2FA</h3>
                <div id="preCheckBox2FA">
                    <h4 class="white mb-2">${translate('PUT_YOUR_PASSWORD')}</h4>
                    <div class="form-group mt-3">
                        <input type="password" id="twofa_user_password_remove" name="password" placeholder="Password" class="form-control">
                        <label class="form-label">Password</label>
                    </div>
                    <button id="remove2FAbtn" class="button-secondary mt-4" onclick="event.preventDefault(); remove2FA();">${translate('REMOVE')}</button>
                </div>
            </div>
        `;
    }

    $('#modal-body-generic').html(html);
    BSLight.ModalShow('#modal-generic');
}

function save2FA() {
    var formData = new FormData();
    formData.append('twofa_code', $('#twofa_code').val());
    $('#save2FAbtn').prop('disabled', true);

    $.ajax({
        type: 'POST',
        url: URL_API2 + '/users/2fa/save',
        cache: false,
        data: formData,
        contentType: false,
        processData: false,
        success: function () {
            userData.twofa_configured = true;
            generateProfileSection(userData);
            BSLight.ModalHide('#modal-generic');
            open_notifications_toast(translate('SAVED') + '!', 'rgb(46, 182, 13)');
            $('#save2FAbtn').prop('disabled', false);
        },
        error: function () {
            $('#save2FAbtn').prop('disabled', false);
            open_notifications_toast(translate('ERROR') + '!', 'rgba(192, 57, 43, 1)');
        }
    });
}

function check2FA() {
    var formData = new FormData();
    formData.append('password', $('#twofa_user_password').val());
    $('#save2FAbtn').prop('disabled', true);

    $.ajax({
        type: 'POST',
        url: URL_API2 + '/users/2fa',
        cache: false,
        data: formData,
        contentType: false,
        processData: false,
        success: function (img) {
            $('#preCheckBox2FA').hide();
            $('#2FAresult').html("<img src='" + img + "' >");
            $('#saveBox2FA').show();
            $('#save2FAbtn').prop('disabled', false);
        },
        error: function () {
            $('#save2FAbtn').prop('disabled', false);
            open_notifications_toast(translate('ERROR') + '!', 'rgba(192, 57, 43, 1)');
        }
    });
}

function remove2FA() {
    var formData = new FormData();
    formData.append('password', $('#twofa_user_password_remove').val());
    $('#remove2FAbtn').prop('disabled', true);

    $.ajax({
        type: 'POST',
        url: URL_API2 + '/users/2fa/delete',
        cache: false,
        data: formData,
        contentType: false,
        processData: false,
        success: function () {
            userData.twofa_configured = false;
            generateProfileSection(userData);
            BSLight.ModalHide('#modal-generic');
            open_notifications_toast(translate('SAVED') + '!', 'rgb(46, 182, 13)');
            $('#remove2FAbtn').prop('disabled', false);
        },
        error: function () {
            $('#remove2FAbtn').prop('disabled', false);
            open_notifications_toast(translate('ERROR') + '!', 'rgba(192, 57, 43, 1)');
        }
    });
}



function openLinkTos() {
    var url = companyDocTos;
    var separator = (url.indexOf('?') !== -1) ? '&' : '?';
    url += separator + 'l=' + currentLang+'&app=1';
    // cordova.InAppBrowser.open(url, '_system');
    cordova.plugins.browsertabs.openUrl(url, {
        authSession: false,
    }, onSuccessBrowserTabOpened, onErrorBrowserTabOpened);
}

function openLinkPrivacy() {
    var url = companyDocPrivacy;
    var separator = (url.indexOf('?') !== -1) ? '&' : '?';
    url += separator + 'l=' + currentLang+'&app=1';
    // cordova.InAppBrowser.open(url, '_system');
    cordova.plugins.browsertabs.openUrl(url, {
        authSession: false,
    }, onSuccessBrowserTabOpened, onErrorBrowserTabOpened);
    
}

function openSupportEmail() {
    // alert(companySupportEmail);
    var url = 'mailto:' + companySupportEmail;
    // cordova.InAppBrowser.open(url, '_system');
    cordova.plugins.browsertabs.openUrlInBrowser(url, onSuccessBrowserTabOpened, onErrorBrowserTabOpened);
}

function rateTheApp(){
    var urlStore;
    if (userDevice == 'android') {
        urlStore = "market://details?id="+PLAY_STORE_ID;
    } else if (userDevice == 'ios') {
        urlStore = "itms-apps://itunes.apple.com/app/id"+APPLE_STORE_ID;
    } else {
        // Gestione delle altre piattaforme
        // alert("La tua piattaforma non è supportata per il download diretto.");
        return;
    }
   
//    cordova.InAppBrowser.open(urlStore, "_system");
    cordova.plugins.browsertabs.openUrlInBrowser(urlStore, onSuccessBrowserTabOpened, onErrorBrowserTabOpened);
}

function deactivateTheAccount(){    
//    cordova.InAppBrowser.open(companyDomain, "_system");
    cordova.plugins.browsertabs.openUrlInBrowser(companyDomain+"/profile?token="+userToken+"&action=deactive-account", onSuccessBrowserTabOpened, onErrorBrowserTabOpened);
}

function openIapSettings(){
    if(userData.has_mobile_payments){
        var urlStore;
        if (userDevice == 'android') {
            urlStore = "https://play.google.com/store/account/subscriptions?package="+PLAY_STORE_ID;
        } else if (userDevice == 'ios') {
            urlStore = "itms-apps://apps.apple.com/account/subscriptions";
        } else {
            // Gestione delle altre piattaforme
            // alert("La tua piattaforma non è supportata per il download diretto.");
            return;
        }

        // cordova.InAppBrowser.open(urlStore, '_system');
        cordova.plugins.browsertabs.openUrlInBrowser(urlStore, onSuccessBrowserTabOpened, onErrorBrowserTabOpened);

    }else{
        openModalPaymentPreview();
    }
}